import { useVideoStore } from "@/store/video";
import { usePlayerStore } from "@/store/player";
import { MiddlewareInterface } from "@/interfaces/Middleware.ts";

// Hash formats supported:
//   #play-{videoId}
//   #play-{videoId}-playlist-{playlistId}
export default async ({ to, pinia }: MiddlewareInterface) => {
  const toHash = to.hash.substring(1) || "";
  const toParts = toHash.split("-");

  const playerStore = usePlayerStore(pinia);

  if (toParts[0] !== "play") {
    if (!playerStore.isPipModeEnabled) {
      await playerStore.setTheaterMode({ videoId: null });
    }

    return;
  }

  if (useVideoStore(pinia).getActiveVideo !== null) {
    return;
  }

  const videoId = parseInt(toParts[1]);
  const rawPlaylistId = toParts[2] === "playlist" ? parseInt(toParts[3]) : null;
  const playlistId = rawPlaylistId !== null && Number.isFinite(rawPlaylistId) ? rawPlaylistId : null;

  await playerStore.setTheaterMode({ videoId, playlistId });
};
